import { Input } from "antd";
import useForgotPassword from "./useForgotPassword";
import Loading from "../../components/loading/Loading";

const ForgotPassword = () => {
    const {
        forgotPasswordHandler, 
        onChangeHandler, 
        payload, 
        loadingPagestate} = useForgotPassword()
    return(
        <div className="container-fluid" style={{ height: "100vh" }}>
            <div className="row h-100">
                <div className="d-flex flex-column align-items-center mt-5">
                    <div className="logo-login mb-5">
                    </div>
                    <div>
                        <h5>
                        <b>Forget Password</b>
                        </h5>
                    </div>
                    <br />
                    <div>
                        <div className="mb-3">
                            <label htmlFor="exampleInputEmail1" className="form-label">
                                Email
                            </label>
                            <Input
                                required
                                type="email"
                                className="login-form"
                                id="Email"
                                name="Email"
                                placeholder="Enter your email"
                                onChange={(e) => onChangeHandler(e)}
                            />
                        </div>
                        <button
                            type="submit"
                            className="btn btn-primary add-button"
                            onClick={(e) => {
                                if (payload.Email != "") {
                                    forgotPasswordHandler(e)
                                }
                            }}
                        >
                            Submit
                        </button>
                    </div>
                </div>
            </div>

            <Loading state={loadingPagestate}/>
        </div>
    )
}

export default ForgotPassword